exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box[data-v-63ef474d] {\r\n    width: 600px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\n}\n.filter-container[data-v-63ef474d] {\r\n    padding: auto;\r\n    margin-left: 20px;\r\n    padding-top: 20px;\n}\n.filter-item[data-v-63ef474d] {\r\n    margin-right: 10px;\r\n    margin-top: 10px;\n}\r\n", ""]);

// exports
